module.exports = __webpack_public_path__ + "img/wat-stew.a2295ae6.webp";